const STORAGE_KEY = 'series65-ai-config';

const VALID_PROVIDERS = ['free', 'groq', 'gemini'];

const DEFAULT_CONFIG = { provider: 'free', groqApiKey: '', geminiApiKey: '' };

export function getAiConfig() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    const parsed = raw ? JSON.parse(raw) : {};
    const merged = { ...DEFAULT_CONFIG, ...parsed };
    if (!VALID_PROVIDERS.includes(merged.provider)) {
      merged.provider = DEFAULT_CONFIG.provider;
    }
    return merged;
  } catch {
    return { ...DEFAULT_CONFIG };
  }
}

export function saveAiConfig(config) {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(config));
}

// Resolves the stored config down to what /api/ai/explain and /api/ai/test-key
// need. Returns null when the selected provider has no key saved yet, so the
// caller can prompt the user to configure one instead of firing a request that
// can only fail.
export function getActiveAiRequestConfig() {
  const config = getAiConfig();
  if (config.provider === 'groq' && config.groqApiKey) {
    return { provider: 'groq', apiKey: config.groqApiKey };
  }
  if (config.provider === 'gemini' && config.geminiApiKey) {
    return { provider: 'gemini', apiKey: config.geminiApiKey };
  }
  return null;
}
